    <div class="d-flex justify-content-end">
      <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
    <h2 style="font-weight:bold;">QR Code Detail</h2>
  <table>
    <tbody>
        <tr *ngFor="let columnName of getColumnNames(data)">
            <td *ngIf="columnName != 'priorityColor'">{{ columnName }}: {{ data[columnName] }}</td>
        </tr>
    </tbody>
   </table>
